import React from 'react';
import { connectSearchBox } from 'react-instantsearch-dom';

export default connectSearchBox(({ refine, currentRefinement, onFocus }) => (
	<form>
		<input
			style={{
				border: 'none',
				textAlign: 'center',
				fontSize: '2rem',
				backgroundColor: 'black',
				color: 'white'
			}}
			type="text"
			placeholder="SEARCH"
			aria-label="Search"
			onChange={(e) => refine(e.target.value)}
			value={currentRefinement}
			onFocus={onFocus}
		/>
	</form>
));
